import React from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useReactFlow, useViewport } from '@xyflow/react';
import { AppState, useCanvasStore } from '../store';
import { COLORS } from '../utils';
import { Cursor } from './cursor';
import { Cursor as CursorType } from './types';
import styles from './index.module.styl';
const selector = (state: AppState) => ({
  others: state.liveblocks.others
});
export function CursorPresence() {
  var _containerRef$current, _containerRef$current2;
  const {
    others
  } = useCanvasStore(useShallow(selector));
  const {
    flowToScreenPosition
  } = useReactFlow();
  const containerRef = React.useRef<HTMLDivElement>(null);
  const containerBounds = (_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.getBoundingClientRect()) !== null && _containerRef$current !== void 0 ? _containerRef$current : {
    left: 0,
    top: 0
  };
  // subscribe to viewport changes to force re-render
  const {
    x: _x,
    y: _y,
    zoom: _zoom
  } = useViewport();
  return <div className={styles.cursorPresence} ref={containerRef} data-sentry-component="CursorPresence" data-sentry-source-file="index.tsx">
      {others.map(_ref => {
      let {
        connectionId,
        presence,
        info
      } = _ref;
      if (!presence.cursor) {
        return null;
      }
      const cursor = presence.cursor as CursorType;
      const screenPosition = flowToScreenPosition({
        x: cursor.x,
        y: cursor.y
      });
      return <Cursor key={connectionId} name={info.name} color={COLORS[connectionId % COLORS.length]} x={screenPosition.x - containerBounds.left} y={screenPosition.y - containerBounds.top} />;
    })}
    </div>;
}